import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "@/lib/firebase";

const LEADS = "leads";

function leadFromDoc(snapshot) {
  const d = snapshot.data();
  const created =
    d.created_at?.toDate?.() != null
      ? d.created_at.toDate().toISOString()
      : typeof d.created_at === "string"
        ? d.created_at
        : new Date().toISOString();
  return {
    id: d.id ?? snapshot.id,
    name: d.name,
    email: d.email,
    startup: d.startup,
    inv_score: d.inv_score,
    bank_score: d.bank_score,
    tag: d.tag,
    sequence: d.sequence,
    answers: d.answers ?? {},
    created_at: created,
  };
}

export async function createLead(payload) {
  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

  const ref = doc(db, LEADS, id);
  await setDoc(ref, {
    id,
    name: payload.name,
    email: payload.email,
    startup: payload.startup,
    inv_score: payload.inv_score,
    bank_score: payload.bank_score,
    tag: payload.tag,
    sequence: payload.sequence,
    answers: payload.answers,
    created_at: serverTimestamp(),
  });

  return { id, ...payload, created_at: new Date().toISOString() };
}

export async function fetchLeadsOrdered() {
  const q = query(collection(db, LEADS), orderBy("created_at", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(leadFromDoc);
}

export function computeDashboardStats(leads) {
  const total_leads = leads.length;
  if (total_leads === 0) {
    return {
      total_leads: 0,
      avg_inv_score: 0,
      avg_bank_score: 0,
      investor_ready: 0,
      bank_ready: 0,
      in_preparation: 0,
      early_stage: 0,
      leads_this_week: 0,
      leads_this_month: 0,
    };
  }

  const sumInv = leads.reduce((s, l) => s + l.inv_score, 0);
  const sumBank = leads.reduce((s, l) => s + l.bank_score, 0);

  const now = new Date();
  const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const monthAgo = new Date(now);
  monthAgo.setMonth(monthAgo.getMonth() - 1);

  const inRange = (iso, from) => new Date(iso) >= from;

  return {
    total_leads,
    avg_inv_score: Math.round((sumInv / total_leads) * 10) / 10,
    avg_bank_score: Math.round((sumBank / total_leads) * 10) / 10,
    investor_ready: leads.filter((l) => l.tag === "investor-ready").length,
    bank_ready: leads.filter((l) => l.tag === "bank-ready").length,
    in_preparation: leads.filter((l) => l.tag === "in-preparazione").length,
    early_stage: leads.filter((l) => l.tag === "early-stage").length,
    leads_this_week: leads.filter((l) => inRange(l.created_at, weekAgo)).length,
    leads_this_month: leads.filter((l) => inRange(l.created_at, monthAgo))
      .length,
  };
}
